// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"63688a71038ed9d8","5387":"1e99622e2f47cd2b"}[chunkId] + ".css";
};